import { setItem } from '../storage';
/*

  1) Change the AB_TEST constant in this file to match your A/B test:
  export const AB_TEST = 'skip_wardrobe_page';

  2) To use it in a React component:
  const isBVersion = useSelector(getIsBVersion(AB_TEST));
  if (isBVersion) {
    // Do something
  }

*/
export let AB_TEST = '';
/* on remote handled AB tests we don't need to store th userGroup
however can be useful for testing purposes */
const setAbVersion = (ab) => {
    setItem(`ab_${AB_TEST}`, ab);
};
export const initABTesting = async (insightsApi, isKiosk, ab) => {
    const cookieOk = insightsApi?.moduleClient;
    if (cookieOk && !isKiosk && ab) {
        AB_TEST = ab.name;
        const abVersion = ab.group.toUpperCase();
        if (AB_TEST.includes('guida')) {
            setAbVersion(abVersion);
            return abVersion === 'B' ? [AB_TEST] : [];
        }
    }
    return [];
};
//# sourceMappingURL=remoteABTest.js.map